exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".forget-container[data-v-6803ed7a]{min-height:100%;width:100%;background-color:#2d3a4b;overflow:hidden}.forget-container .login-form[data-v-6803ed7a]{position:relative;width:520px;max-width:100%;padding:160px 35px 0 0;margin:0 auto;overflow:hidden}.forget-container .title-container[data-v-6803ed7a]{position:relative}.forget-container .title-container .title[data-v-6803ed7a]{font-size:26px;color:#eee;margin:0px auto 40px auto;text-align:center;font-weight:bold}.forget-container .title-container .set-language[data-v-6803ed7a]{color:#fff;position:absolute;top:3px;font-size:18px;right:0px;cursor:pointer}\n", ""]);

// exports
